import { useState } from 'react';
import RevealLines from '@/components/base/RevealLines';
import { stories } from '@/mocks/site';

const fillClass: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-200',
  ink: 'bg-foreground-950',
};
const numClass: Record<string, string> = {
  primary: 'text-background-50',
  accent: 'text-foreground-950',
  ink: 'text-background-50',
};

export default function People() {
  const [active, setActive] = useState(0);

  return (
    <section id="inside" aria-label="Inside FORM & FEEL" className="bg-background-50 overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 px-4 md:px-6 pt-24 md:pt-32 pb-14 md:pb-20">
        <RevealLines lines={['Inside', 'Form & Feel']} className="md:col-span-7 font-extrabold tracking-[-0.055em] leading-[0.88] text-[clamp(2.8rem,8vw,8.5rem)]" />
        <div className="md:col-span-4 md:col-start-9 md:self-end" data-reveal="up">
          <p className="font-label text-[11px] uppercase tracking-[0.18em] text-secondary-600">Inside / 05</p>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-800 max-w-[340px]">
            Good things happen together. Notes from the studio floor and the people behind every moment.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-14 md:gap-6 px-4 md:px-6 pb-24 md:pb-32">
        {stories.map((s, i) => {
          const on = active === i;
          return (
            <article key={s.label} className="flex flex-col items-center text-center" onMouseEnter={() => setActive(i)}>
              <button
                type="button"
                aria-pressed={on}
                aria-label={`Show story: ${s.title}`}
                onClick={() => setActive(i)}
                onFocus={() => setActive(i)}
                className={`relative w-[72vw] max-w-[340px] md:w-[26vw] aspect-square rounded-full overflow-hidden cursor-pointer transition-transform duration-700 ease-[cubic-bezier(.22,1,.36,1)] ${on ? 'scale-100' : 'scale-[0.62]'}`}
              >
                <span className={`absolute inset-0 ${fillClass[s.marker]}`} />
                <img
                  src={s.src}
                  alt={s.alt}
                  className={`absolute inset-0 h-full w-full object-cover object-top transition-[opacity,transform] duration-700 ${on ? 'opacity-100 scale-100' : 'opacity-0 scale-110'}`}
                />
                <span className={`absolute inset-0 flex items-center justify-center font-heading font-extrabold tracking-[-0.06em] text-[clamp(3rem,7vw,6rem)] transition-opacity duration-500 ${numClass[s.marker]} ${on ? 'opacity-0' : 'opacity-100'}`}>
                  0{i + 1}
                </span>
              </button>
              <p className="mt-6 font-label text-[10px] uppercase tracking-[0.18em] text-secondary-600">{s.label}</p>
              <h3 className="mt-3 text-xl md:text-2xl font-semibold tracking-[-0.025em] leading-snug max-w-[320px]">{s.title}</h3>
              <p className={`mt-3 text-sm leading-relaxed text-foreground-700 max-w-[320px] transition-opacity duration-500 ${on ? 'opacity-100' : 'opacity-100 md:opacity-40'}`}>{s.excerpt}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}